import React from 'react';
import {Popup} from "react-leaflet";
import parse from "html-react-parser";
import {Coordinates, MarkerInfo} from "../../../../../core/types/types";

interface SingleMarkerFixedPopupProps {
    marker: Coordinates;
}

const SingleMarkerFixedPopup : React.FC<SingleMarkerFixedPopupProps> = ({
    marker
 }) => {
    return (
        <>
            <>
                <Popup
                    className="fixed-popup"
                    position={[marker.lat, marker.lng]}
                    closeButton={false}
                    autoClose={false}
                    autoPan={false}
                    closeOnClick={false}
                >
                    {marker.fixedModalBody && parse(marker.fixedModalBody)}
                </Popup>
            </>
        </>
    );
};

export default SingleMarkerFixedPopup;